import { defineStore } from 'pinia';
import notificationWrapper from '../utils/helpers/notificationWrapper';
import { useProjectStore } from './projectStore';

export const useProfileStore = defineStore('profile', {
  state: () => ({
    cardsPayment: [],
    contentCardPayment: null,
    profile: null,
    cardLoading: false,
    isCardInfoLoading: false,
    isDeletingCardPaymentDisplayed: false,
    isProfileLoading: false,
    isUpdateEmailLoading: false,
    isPostPasswordLoading: false,
  }),

  actions: {
    async getCardsPayment() {
      this.isCardInfoLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getCardsPayment(projectStore.projectIdSelected);
        if (data?.card_info) {
          this.cardsPayment = data.card_info;
          this.isCardInfoLoading = false;
        }
      } catch (error) {
        this.isCardInfoLoading = false;
        throw error;
      }
    },

    async updateCardPayment(form: any) {
      this.isCardInfoLoading = true;
      try {
        const projectStore = useProjectStore();
        await window.appConnector.updateCardPayment(projectStore.projectIdSelected, form);
        notificationWrapper('success', 'UPDATE_CB_SAVE');
        this.isCardInfoLoading = false;
      } catch (error) {
        notificationWrapper();
        this.isCardInfoLoading = false;
        throw error;
      }
    },

    async deleteCardPayment(id: string) {
      this.isCardInfoLoading = true;
      try {
        const projectStore = useProjectStore();
        await window.appConnector.deleteCardPayment(projectStore.projectIdSelected, id);
        notificationWrapper('success', 'DELETE_CB_SAVE');
        this.isCardInfoLoading = false;
        const findCardIndex = this.cardsPayment.findIndex((item: any) => item.pm_id === id);
        if (findCardIndex !== -1) {
          this.cardsPayment.splice(findCardIndex, 1);
        }
      } catch (error) {
        notificationWrapper('error', error.data && error.data.error);
        this.isCardInfoLoading = false;
        throw error;
      }
    },

    async getProfile() {
      this.isProfileLoading = true;
      try {
        const data = await window.appConnector.getProfile();
        if (data) {
          this.profile = data;
          this.isProfileLoading = false;
        }
      } catch (error) {
        this.isProfileLoading = false;
        throw error;
      }
    },

    async updateEmail(form: any) {
      this.isUpdateEmailLoading = true;
      try {
        await window.appConnector.updateEmail(form);
        notificationWrapper('success', 'UPDATE_EMAIL');
        this.isUpdateEmailLoading = false;
      } catch (error) {
        notificationWrapper('error', 'UPDATE_EMAIL');
        this.isUpdateEmailLoading = false;
        throw error;
      }
    },

    async postPassword(form: any) {
      this.isPostPasswordLoading = true;
      try {
        await window.appConnector.postPassword(form);
        await this.getProfile();
        notificationWrapper('success', 'POST_PASSWORD');
        this.isPostPasswordLoading = false;
      } catch (error) {
        notificationWrapper('error', 'POST_PASSWORD');
        this.isPostPasswordLoading = false;
        throw error;
      }
    },

    setDeleteCardPaymentModalDisplayed(content: any) {
      this.isDeletingCardPaymentDisplayed = true;
      this.contentCardPayment = content;
    },

    unsetDeleteCardPaymentModalDisplayed() {
      this.isDeletingCardPaymentDisplayed = false;
      this.contentCardPayment = null;
    },
  },
});
